 
export const SEARCH_RESULT = "SEARCH_RESULT";

// export default {SEARCH_RESULT }
